module.exports = __webpack_public_path__ + "img/help.aae827b4.svg";